import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, LogIn, ArrowLeft } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login, profile } = useApp();
  const navigate = useNavigate();
  const [creds, setCreds] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (profile?.role === "admin") navigate("/admin/dashboard");
  }, [profile, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const p = await login(creds.email, creds.password);
      if (p.role !== "admin") {
        toast.error("These credentials are not for an admin account.");
        return;
      }
      toast.success("Welcome, Admin.");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid admin credentials.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen clean-bg flex items-center justify-center p-4 relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-primary-600/15 rounded-full blur-[120px] pointer-events-none" />
      <button onClick={() => navigate("/")} className="absolute top-6 left-6 text-zinc-400 hover:text-white flex items-center text-sm font-medium transition-colors">
        <ArrowLeft size={16} className="mr-2" /> Back to site
      </button>
      <div className="glass-panel bg-[#0a0a0b]/90 rounded-3xl w-full max-w-md relative fade-in border border-white/10 shadow-[0_0_50px_rgba(0,0,0,0.5)]">
        <div className="p-8 md:p-10">
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary-900/50 text-primary-400 rounded-2xl flex items-center justify-center mx-auto mb-5 border border-primary-500/30 shadow-[0_0_20px_rgba(59,130,246,0.3)]">
              <ShieldCheck size={28} />
            </div>
            <div className="text-2xl font-extrabold tracking-tight font-display mb-1">DONDR<span className="text-primary-400">Á</span>E</div>
            <h1 className="text-xl font-bold text-white">Admin Console</h1>
            <p className="text-zinc-500 text-sm mt-1">Restricted access. Authorized personnel only.</p>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="block text-xs font-bold text-zinc-400 uppercase tracking-wider mb-2">Admin Email</label>
              <input type="email" value={creds.email} onChange={(e) => setCreds({ ...creds, email: e.target.value })} required className="w-full px-5 py-3.5 rounded-xl dark-input" placeholder="admin@dondrae.com" />
            </div>
            <div>
              <label className="block text-xs font-bold text-zinc-400 uppercase tracking-wider mb-2">Password</label>
              <input type="password" value={creds.password} onChange={(e) => setCreds({ ...creds, password: e.target.value })} required className="w-full px-5 py-3.5 rounded-xl dark-input" placeholder="••••••••" />
            </div>
            <button type="submit" disabled={submitting} className="w-full py-4 bg-primary-600 text-white rounded-xl font-bold hover:bg-primary-500 transition-colors shadow-[0_0_20px_rgba(59,130,246,0.4)] border border-primary-400/50 flex items-center justify-center disabled:opacity-60">
              {submitting ? "Verifying…" : (<>Access Console <LogIn size={18} className="ml-3" /></>)}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
